export default {
      id: "jp-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#jp",
      toString: function () {
        return this.url;
      }
    }